import { metricsLog } from './utils';
import { VideoProvider } from '../../constants/Video';
import { EventTypeV3 } from '../beacon';

// below is the correct playinc id
// const PLAYINC_TCF_ID = '621611a993957006d885f789';

// temporary fix before indy update the sourcepoint purposes for playinc
const PLAYINC_TCF_ID = '6184fd2b293cdf8a4a108fe6';

export const waitForConsent = () => new Promise((resolve, reject) => {
  const callback = (data: any, success: boolean) => {
    if (success) {
      const playinc = data.grants[PLAYINC_TCF_ID];
      metricsLog(`TCF playinc / ${playinc}: `, playinc, data);
      return resolve(Boolean(playinc?.vendorGrant));
    }
    reject('Consent failed');
  };

  if (typeof window.__tcfapi === 'function') {
    window.__tcfapi('getCustomVendorConsents', 2, callback);
    return;
  }

  window.addEventListener('consentReady', () => {
    if (window.__tcfapi && typeof window.__tcfapi === 'function') {
      window.__tcfapi('getCustomVendorConsents', 2, callback);
    }
    reject('__tcfapi not found');
  });
});

export const scriptLoader = async (src: string, async = true): Promise<void> =>
  new Promise((resolve, reject) => {
    if (!src) return reject('Please provide script source');

    const script = window.document.createElement<'script'>('script');
    script.async = async;
    script.src = src;
    script.onload = () => resolve();
    script.onerror = reject

    try {
      document.body.appendChild(script);
    } catch (ex) {
      reject('Fails to inject script. Possibly the document is not ready.');
    }
  });

export const scriptLoaderToTopPage = async (src: string, async = true): Promise<void> =>
  new Promise((resolve, reject) => {
    if (!src) return reject('Please provide script source');

    const script = window.top.document.createElement<'script'>('script');
    script.async = async;
    script.src = src;
    script.onload = () => resolve();
    script.onerror = reject

    try {
      window.top.document.body.appendChild(script);
    } catch (ex) {
      reject('Fails to inject script. Possibly the document is not ready.');
    }
  });

const tcfApiExists = async () => new Promise((resolve, reject) => {
  // because kooora executing us after dom loaded, we can just check the tcf straight away
  resolve(window.top.__tcfapi && typeof window.top.__tcfapi === 'function');
});

export const dispatchEmbedEvent = (swappedMediaId: string = null) => {
  const key = window.top.__pixelsLayerKey || 'pixelsLayer';
  const layer = window.top[key] || [];
  layer.swappedVideoId = swappedMediaId;
  layer.push({
    type: EventTypeV3.EMBED
  });

  window.top[key] = layer;
}


export const metricsInit = async (...params: [string | any, VideoProvider, string]) => {
  if (!/localhost|pub-dev/.test(__PUB_ENDPOINT__)) {
    if (params[1] === VideoProvider.FCPLAYER) {
      // disable for now, allow for anyone
      // const isGdpr = await tcfApiExists();
      // if (isGdpr) {
      //   console.warn('Site is GDPR compliance, do not proceed with tracking');
      //   return;
      // }
    } else {
      await waitForConsent();
    }
  }

  window._pixelsPlayer = window._pixelsPlayer || [];
  window._pixelsPlayer.push([...params]);
  await scriptLoader(`${__PUB_ENDPOINT__}/metrics-lib.js`);
};

export const metricsInitWithoutConsentCheck = async (...params: [string | any, VideoProvider, string]) => {
  window._pixelsPlayer = window._pixelsPlayer || [];
  window._pixelsPlayer.push([...params]);
  await scriptLoader(`${__PUB_ENDPOINT__}/metrics-lib.js`);
};
